import { createSlice } from '@reduxjs/toolkit';
import { MachineRequestState, t_equipment_lease } from 'types';
import { Patient } from 'types';
import { filterListPatient } from '../MachineUpdate/thunk';
import { getDataStoreFieldsMachine, getDetailMachine, getListMachine } from './thunk';

interface InitialState {
  items: t_equipment_lease[];
  totalItems: number;
  currentPage: number;
  searchValue: MachineRequestState | undefined;
  dataStoreFields?: any[];
  itemDetail?: t_equipment_lease;
  listPatient?: Patient[];
}

const initialState: InitialState = {
  items: [],
  totalItems: 0,
  currentPage: 1,
  searchValue: undefined,
};

const machineSlices = createSlice({
  name: 'machine',
  initialState,
  reducers: {
    resetItemDetail(state) {
      return { ...state, itemDetail: undefined };
    },
    setSearchValue(state, action) {
      state.searchValue = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    resetSearchValue(state) {
      state.searchValue = undefined;
      state.currentPage = 1;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getListMachine.fulfilled, (state, action) => {
      return { ...state, ...action.payload };
    });
    builder.addCase(getDataStoreFieldsMachine.fulfilled, (state, action) => ({
      ...state,
      dataStoreFields: Object.entries(action.payload.data.fields),
    }));
    builder.addCase(getDetailMachine.fulfilled, (state, action) => ({ ...state, itemDetail: action.payload }));
    builder.addCase(filterListPatient.fulfilled, (state, action) => ({ ...state, listPatient: action.payload }));
  },
});

export const { resetItemDetail, resetSearchValue, setCurrentPage, setSearchValue } = machineSlices.actions;
export default machineSlices.reducer;
